import { EmployeeMeritComponent } from './components/employee-merit/employee-merit.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeAuthGuard } from './../shared/services/employee-auth-guard.service';
import { AuthGuard } from './../shared/services/auth-guard.service';
import { EmployeeComponent } from './employee.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileFormComponent } from './components/profile-form/profile-form.component';
import { ProfileContactFormComponent } from './components/profile-contact-form/profile-contact-form.component';
import { OtherDetailsComponent } from './components/other-details/other-details.component';
import { DiseaseInfoComponent } from './components/disease-info-form/disease-info-form.component';
import { DisabledInfoFormComponent } from './components/disabled-info-form/disabled-info-form.component';
import { SingleWomenInfoComponent } from './components/single-women-info-form/single-women-form.component';
import { SpouseInInfoComponent } from './components/spouse-in-info-form/spouse-in-info-form.component';
import { SpouseOutInfoComponent } from './components/spouse-out-info-form/spouse-out-info-form.component';
import { PresentPlaceFormComponent } from './components/present-place-form/present-place-form.component';
import { ServiceBookFormComponent } from './components/service-book/service-book-form/service-book-form.component';
import { ServiceBookListComponent } from './components/service-book/service-book-list/service-book-list.component';
import { TransferRequestComponent } from './components/transfer-request-form/transfer-request-form.component';
import { VacantPostComponent } from './components/vacant-post/vacant-post.component';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';
import { TransferRequestUnlockComponent } from './components/transfer-request-unlock/transfer-request-unlock.component';
import { ProfileThumbFormComponent } from './components/profile-thumb-form/profile-thumb-form.component';
import { GrivanceComponent } from './components/grivance/grivance.component';
import { AddGivanceComponent } from './components/grivance/add-givance/add-givance.component';
import { ViewGivanceComponent } from './components/grivance/view-givance/view-givance.component';
import { EmployeeViewComponent } from '../shared/components/employee-view/employee-view.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: "Employee" },
    component: EmployeeComponent,
    canActivate: [AuthGuard, EmployeeAuthGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'Employee' },
        component: DashboardComponent
      },
      {
        path: 'merit',
        data: { breadcrumb: 'Employee Merit' },
        component: EmployeeMeritComponent
      },
      {
        path: 'profile',
        data: { breadcrumb: 'Profile' },
        children: [
          { path: '', component: ProfileFormComponent, data: { breadcrumb: "Profile" } },
          { path: 'thumb', component: ProfileThumbFormComponent, data: { breadcrumb: "Thumb" } },
          { path: 'contact', component: ProfileContactFormComponent, data: { breadcrumb: "Contact Details" } },
          {
            path: 'other-details',
            data: { breadcrumb: "Other Details" },
            children: [
              { path: '', component: OtherDetailsComponent, data: { breadcrumb: "Other Details" } },
              { path: 'disabled-info', component: DisabledInfoFormComponent, data: { breadcrumb: "Vacant Posts" } },
              { path: 'disease-info', component: DiseaseInfoComponent, data: { breadcrumb: "New" } },
              { path: 'single-women-info', component: SingleWomenInfoComponent, data: { breadcrumb: "Edit" } },
              { path: 'spouse-in-info', component: SpouseInInfoComponent, data: { breadcrumb: "Edit" } },
              { path: 'spouse-out-info', component: SpouseOutInfoComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'service-book',
        data: { breadcrumb: "Service Book" },
        children: [
          { path: '', component: ServiceBookListComponent, data: { breadcrumb: "Service Book" } },
          { path: 'present-place', component: PresentPlaceFormComponent, data: { breadcrumb: "Service Book" } },
          { path: 'new', component: ServiceBookFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: ServiceBookFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
      {
        path: 'transfer-request',
        data: { breadcrumb: "Transfer Request" },
        children: [
          { path: '', component: TransferRequestComponent, data: { breadcrumb: "Transfer Request" } },
          { path: 'preference', component: VacantPostComponent, data: { breadcrumb: "Preference" } },
          { path: 'view', component: TransferRequestViewComponent, data: { breadcrumb: "Transfer Request" } },
          { path: 'unlock', component: TransferRequestUnlockComponent, data: { breadcrumb: "Transfer Request" } },
        ]
      },
      {
        path: 'grievance',
        data: { breadcrumb: 'grievance' },
        children: [
          { path: '',component: GrivanceComponent },
          { path: 'add-grievance', component: AddGivanceComponent ,data: { breadcrumb: 'Add grievance' } },
          { path: 'view-grievance',component: ViewGivanceComponent , data: { breadcrumb: 'View Service Request' } },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeRoutingModule { }
